// Function to check if localStorage is available and accessible
export const isLocalStorageAvailable = (): boolean => {
  try {
    const testKey = "__localStorage_test__";
    localStorage.setItem(testKey, "test");
    localStorage.removeItem(testKey);
    return true;
  } catch (error) {
    console.warn("localStorage is not available:", error);
    return false;
  }
};

// Function to set item in localStorage with a unique prefix

interface SetLocalStorageItemProps {
  botId: string;
  key: string;
  value: any;
  filterId?: string;
}
interface GetLocalStorageItemProps {
  botId: string;
  key: string;
  filterId?: string;
}
interface RemoveLocalStorageItemProps {
  botId: string;
  key: string;
  filterId?: string;
}
export const setLocalStorageItem = ({
  botId,
  key,
  value,
  filterId,
}: SetLocalStorageItemProps) => {
  try {
    let prefixedKey = `${botId}_${key}`;
    if (filterId) {
      prefixedKey = `${botId}_${filterId}_${key}`;
    }
    localStorage.setItem(prefixedKey, JSON.stringify(value));
  } catch (error) {
    // Handle SecurityError when localStorage is blocked/disabled
    console.warn("localStorage.setItem failed:", error);
    // Silently fail - app should continue working without localStorage
  }
};

// Function to get item from localStorage with a unique prefix
export const getLocalStorageItem = ({
  botId,
  key,
  filterId,
}: GetLocalStorageItemProps) => {
  try {
    let prefixedKey = `${botId}_${key}`;
    if (filterId) {
      prefixedKey = `${botId}_${filterId}_${key}`;
    }
    const value = localStorage.getItem(prefixedKey);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    // Handle SecurityError when localStorage is blocked/disabled
    console.warn("localStorage.getItem failed:", error);
    // Return null when localStorage is not accessible
    return null;
  }
};

// Function to remove item from localStorage with a unique prefix
export const removeLocalStorageItem = ({
  botId,
  key,
  filterId,
}: RemoveLocalStorageItemProps) => {
  try {
    let prefixedKey = `${botId}_${key}`;
    if (filterId) {
      prefixedKey = `${botId}_${filterId}_${key}`;
    }
    localStorage.removeItem(prefixedKey);
  } catch (error) {
    // Handle SecurityError when localStorage is blocked/disabled
    console.warn("localStorage.removeItem failed:", error);
    // Silently fail - app should continue working without localStorage
  }
};
